import { render, staticRenderFns } from "./CalendarEditRoomStatusForm.vue?vue&type=template&id=d48628de&scoped=true&"
import script from "./CalendarEditRoomStatusForm.vue?vue&type=script&lang=js&"
export * from "./CalendarEditRoomStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEditRoomStatusForm.vue?vue&type=style&index=0&id=d48628de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48628de",
  null
  
)

export default component.exports